
export const FETCH_GOLD_START = "FETCH_GOLD_START";
export const FETCH_GOLD_SUCCESS = "FETCH_GOLD_SUCCESS";
export const FETCH_GOLD_ERROR = "FETCH_GOLD_ERROR";